<template>
  <div id="contenedor-eliminar-catalogo-insumo">
    <v-card>
      <v-card-title class="secondary--text">
        Eliminar insumo
      </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el insumo "{{ insumoEliminar.descripcion }}"?
        </span>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarCatalogoInsumo"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoInsumos from './mixCatalogoInsumos';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoInsumoEliminar',
  mixins: [mixCatalogoInsumos],
  props: {
    insumoEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },

  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
